<template>
  <div>
    <b-form class="b-layout" @submit.prevent="">
      <div>
        <label>{{ $t('titulo') }}</label>
        <b-input class="input-pentagro" v-model="title"></b-input>
      </div>

      <SelectPropertie
        :node="node"
        @changedButton="changeButton = $event"
        @typeSelected="node.dataType = $event"
        @propSelected="form.attr = $event[0]"
        @checkChangesOP="checkChangeOnOpForm = $event"
        @checkChangesCt="checkChangeOnCtForm = $event"
        @receiveAttrs="receiveAttrs = $event"
        @currentSelected="form.current = $event"
        @SelectedCurrent="currentForIndex = $event"
        >
      >
      </SelectPropertie>

      <b-icon
          v-if="form.attr"
          class="btn-iconAdd"
          icon="plus-circle-fill"
          @click="addAttr(form.attr)"
          aria-hidden="true"
        />

      <table v-if="tableAttr.length > 0" class="table table-sm mt-2">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{ $t('atributo') }}</th>
            <th scope="col">{{ $t('valor') }}</th>
            <th scope="col">{{$t('unit.')}}</th>
          </tr>
        </thead>
        <tbody v-for="(attr, i) in tableAttr" :key="i">
          <tr>
            <th>
              <b-icon
                class="btn-icon"
                icon="dash-circle-fill"
                @click="removeAttr(i)"
              />
            </th>
            <td>
              <input type="text" v-model="attr.caption" class="attr-name" />
            </td>
            <td>{{ attr.value | ParseNumber }}</td>
            <td><input type="text" v-model="attr.unit" class="attr-unit" /></td>
          </tr>
        </tbody>
      </table>
      <!-- /ATRIBUTOS -->
    </b-form>

    <b-form-checkbox
        v-if="form.current"
        class="ml-2"
        v-model="refActive"
        @change="updateNode"
      >
        {{ $t('ativar-visualizacao-por-referencia') }}
    </b-form-checkbox>
  </div>
</template>

<script>
import { SingletonEnginnering } from '../_service/singletonEngineering';
import SelectPropertie from "../../dialogForm/template/SelectPropertie.vue"
import { formatBR }             from '../../../flowchart/utils/numbers.js';       // 🆕 usa formatter único
import { FiltersMixin }         from '../../../mixins/filtersMixin.js'; // 🆕 pipe ParseNumber novo

export default {
  mixins: [ FiltersMixin ],
  props: {
    node: {
      type: Object,
      default: null,
    },
  },

  components: { SelectPropertie },

  data() {
    return {
      title: this.node.title,
      currents: SingletonEnginnering.currents,
      operations: SingletonEnginnering.operations,
      buttonSelected: { current: false, operation: false },
      currentProperties: "",
      attrSelected: "",
      refActive: true,
      tableAttr: new Array(),
      changeButton: null,
      checkChangeOnOpForm: "",
      checkChangeOnCtForm: "",
      receiveAttrs: "",
      currentForIndex: "",
      verifyOpenning: false,
      form: {
        attr: "",
        title: "",
        current: "",
      },
    };
  },

  watch: {
    title() {
      this.updateNode()
    },

    checkChangeOnOpForm() {
      if(!this.verifyOpenning) {
        this.resetAttrListOp();
      }
    },

    checkChangeOnCtForm() {
      if(!this.verifyOpenning) {
          this.resetAttrListCt();
      }
    },

    tableAttr() {
      this.updateNode()
    },

    refActive(){
      this.updateNode();
    },

    changeButton(value){
      if(this.node.dataType != value){
        this.node.dataType = value
        this.tableAttr = new Array
      }
    },

    "form.current"(value){
      if(this.node.data[0] && this.node.data[0].index != value){
        this.tableAttr = new Array
      }
    }
  },

  methods: {
    resetAttrListOp() {
      let tableAttrTemp = this.tableAttr
      this.tableAttr = []

      this.receiveAttrs.forEach(newElement => {
        tableAttrTemp.forEach(oldElement => {
        if (newElement.key == oldElement.key) {
            newElement.unit = oldElement.unit;
            newElement.caption = oldElement.caption; 
            this.tableAttr.push(newElement);
          }
        });
      });
    },

    resetAttrListCt() {
      let tableAttrTemp = this.tableAttr
      this.tableAttr = []
      let atributesCurrent = SingletonEnginnering.getAllPropertiesInCurrent(this.currentForIndex);

      atributesCurrent.forEach(newElement => {
        tableAttrTemp.forEach(oldElement => {
          if ((newElement.key == oldElement.key) && (newElement.propName == oldElement.propName)) {
            newElement.unit = oldElement.unit;
            newElement.caption = oldElement.caption;
            this.tableAttr.push(newElement);
          }
        });
      });
    },

    updateNode() {
      this.node.title = this.title
      this.node.attrs = this.tableAttr;
      this.node.refActive = this.refActive && this.form.current
    },

    addAttr(attr) {

      if (
        attr &&
        !(this.tableAttr.filter((a) => a.isEquals(attr)).length > 0)
      ) {
        attr.value = formatBR(attr.value); 
        this.tableAttr.push(attr);
      }

      this.node.dataType =
        this.tableAttr[0] && this.tableAttr[0].type
          ? this.tableAttr[0].type
          : this.node.dataType;
      this.updateNode()
    },

    removeAttr(index) {
      let remove = this.tableAttr[index];
      this.tableAttr = this.tableAttr.filter((l) => l.id != remove.id);

      this.node.dataType =
        this.tableAttr[0] && this.tableAttr[0].type
          ? this.tableAttr[0].type
          : this.node.dataType;
      this.updateNode()
    },

    loadNode() {
      this.verifyOpenning = true;

      if (!this.node.dataType || this.node.data.length == 0) {
        setTimeout(() => {
          this.verifyOpenning = false;
        }, 100);

        return;
      } 
      
      this.refActive = this.node.refActive;
      this.tableAttr = this.node.data.map(a => ({ ...a, value: formatBR(a.value) }));

      setTimeout(() => {
        this.verifyOpenning = false;
      }, 100);
    },
  },

  mounted() {
    this.loadNode();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.node-attr {
  display: flex;
  align-items: center;
}


.btn-iconAdd {
  font-size: 25px;
  cursor: pointer;
  margin-left: calc(50% - 12.5px);
  margin-top: 8px;
}

table .btn-icon {
  font-size: 17px;
  cursor: pointer;
}


.attr-unit {
  width: 50px;
}
</style>
